export default "__VITE_ASSET__CEbtdduq__"